import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Tag>
  );
};

export const SectionHead = ({ eyebrow, title, dark = false, children }) => (
  <div>
    <p className={dark ? "eyebrow-lime" : "eyebrow"}>{eyebrow}</p>
    <h2 className={`mt-3 h-section ${dark ? "text-white" : ""}`}>{title}</h2>
    {children}
  </div>
);
